/** @jsxImportSource @emotion/react */
import * as s from './style'
import React, { useEffect, useState } from 'react';
import CategoryMenu from 'components/lab/lab_1/mode_select/category_menu/CategoryMenu';
import SidoList from 'components/lab/lab_1/mode_select/sido_list/SidoList';
import YearSelector from 'components/lab/lab_1/mode_select/year_selector/YearSelector';
import SummaryTable from 'components/lab/lab_1/mode_select/summary_table/SummaryTable';
import SummaryGraph from 'components/lab/lab_1/mode_select/summary_graph/SummaryGraph';
import { BsTable } from "react-icons/bs";
import AllSggTable from 'components/lab/lab_1/mode_select/all_sgg_table/AllSggTable';
import CustomMap from 'components/lab/lab_1/mode_select/map/CustomMap';
import ModalOpenButton from 'components/lab/lab_1/mode_select/icon_button/modalOpenButton';

const ModeSelect = () => {
    const [ selectedCategories, setSelectedCategories ] = useState([]);
    const [ selectedCategoryIndex, setSelectedCategoryIndex ] = useState(0);

    const [ selectedSido, setSelectedSido ] = useState();
    const [ selectedSgg, setSelectedSgg ] = useState({ adminCd: "", adminNm: ""});

    const [allSggTableFlag, setAllSggTableFlag] = useState(false);

    const [mode, setMode] = useState('singleMap');

    useEffect(() => {
        if(selectedCategories.length === 1) {
            const newArray = [selectedCategories[0], selectedCategories[0]];
            setSelectedCategories(newArray);
        }
    }, [selectedCategories])

    useEffect(() => {
        if(mode === 'singleMap') {
            setSelectedCategoryIndex(0);
        }
    }, [mode])

    const setSelectedCategoryByIndex = (newCategory) => {
        setSelectedCategories((prev) => {
            const updatedArray = [...prev];
            updatedArray[selectedCategoryIndex] = newCategory;
            return updatedArray;
        });
    };

    const onClickOpenAllSggTableButton = async () => {
        setAllSggTableFlag(!allSggTableFlag);
    };

    const setSelectedYear = (newYear) => {
        setSelectedCategories((prev) => {
            const updatedArray = [...prev];
            const targetCategory = { ...updatedArray[selectedCategoryIndex], year: newYear };
            updatedArray[selectedCategoryIndex] = targetCategory;
            return updatedArray;
        });
    };

    return (
        <div css={s.mainContainer}>
            <div css={s.tableContainer}>
                <header css={s.header}>
                    <span>다양한 데이터를 확인할 수 있어요!</span>
                    <SidoList setSelectedSido={setSelectedSido} />
                </header>
                <div css={s.categoryContainer}>
                    <div css={s.singleCategoryHeader(mode === 'singleMap')}>
                        <span>주제 선택</span>
                    </div>
                    <div css={s.doubleCategoryHeader(mode !== 'singleMap')}>
                        <div
                            css={s.categorySelector(selectedCategoryIndex === 0)}
                            onClick={() => setSelectedCategoryIndex(0)}
                        >
                            <span>주제 1 선택</span>
                        </div>
                        <div
                            css={s.categorySelector(selectedCategoryIndex === 1)}
                            onClick={() => setSelectedCategoryIndex(1)}
                        >
                            <span>주제 2 선택</span>
                        </div>
                    </div>
                    <CategoryMenu selectedCategory={selectedCategories[selectedCategoryIndex]} setSelectedCategory={setSelectedCategoryByIndex}/>
                </div>

                <div css={s.yearSelectorContainer}>
                    <span css={s.categoryName}>{selectedCategories.length > 1 ? selectedCategories[selectedCategoryIndex].nm_kor : ""}</span>
                    <YearSelector selectedYear={selectedCategories[selectedCategoryIndex]?.year} setSelectedYear={setSelectedYear} selectedCategory={selectedCategories[selectedCategoryIndex]} selectedCategoryIndex={selectedCategoryIndex} />
                    <ModalOpenButton icon={BsTable} onClick={onClickOpenAllSggTableButton}>전국통계보기</ModalOpenButton>
                </div>
                <SummaryTable data={selectedCategories[selectedCategoryIndex]?.data} selectedYear={selectedCategories[selectedCategoryIndex]?.year} selectedCategory={selectedCategories[selectedCategoryIndex]} selectedSgg={selectedSgg} setSelectedSgg={setSelectedSgg}/>

                
                {allSggTableFlag
                    ? <AllSggTable data={selectedCategories[selectedCategoryIndex]?.data} selectedYear={selectedCategories[selectedCategoryIndex]?.year} selectedCategory={selectedCategories[selectedCategoryIndex]} selectedSgg={selectedSgg} setSelectedSgg={setSelectedSgg} setFlag={setAllSggTableFlag}/>
                    : <SummaryGraph data={selectedCategories[selectedCategoryIndex]?.data} selectedCategory={selectedCategories[selectedCategoryIndex]} selectedSgg={selectedSgg}/>
                }

            </div>
            <div css={s.mapContainer}>
                <header css={s.header}>
                    {selectedCategories.length > 0 && (
                        <div css={s.mapHeader}>
                            <div css={s.mapHeaderItem}>{selectedCategories[0].nm_kor}</div>
                        </div>
                    )}
                    {selectedCategories.length > 0 && mode !== 'singleMap' && (
                        <div css={s.mapHeader}>
                            <div css={s.mapHeaderItem}>{selectedCategories[1].nm_kor}</div>
                        </div>
                    )}
                </header>
                <CustomMap selectedCategories={selectedCategories} selectedSido={selectedSido} selectedSgg={selectedSgg} setSelectedSgg={setSelectedSgg} mode={mode} setMode={setMode} />
            </div>
        </div>
    );
};

export default ModeSelect;
